import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RemoveProductGroupingInput } from './RemoveProductGroupingInput';
import { RemoveProductGroupingOutput } from './RemoveProductGroupingOutput';

export class RemoveProductGroupingService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: RemoveProductGroupingInput): Promise<Result<RemoveProductGroupingOutput> | null> => {
    const promise = this.http.delete<Result<RemoveProductGroupingOutput>>(`${this.baseUrlSislogApi}/v2/product-grouping/${input.id}`);
    return promise;
  }
}